import Glide from '@glidejs/glide'

export const PXCarousel = (function() {
	'use strict';

	function init() {
		events();
	}

	function events() {
		let $glides = $('.glide');
		if($glides.length < 1 ) {
			return;
		}

		$glides.each(function(){
			let $this = $(this);

			new Glide( this, {
				type: 'carousel',
			}).on(['run.after', 'mount.after'], function() {
				// Handler logic ...
				let $active = $this.find('.glide__slide--active');
				let $nextText = $this.find('.pxblock--carousel__next-text span');
				let $sibling = $active.next();
				// console.log( $($sibling.find('h3')[0]) );
				$($nextText).fadeOut(function() {
					$nextText.text($sibling.find('h3')[0].textContent)
				}).fadeIn();
			}).mount()
		})
	}

	return {
		init: init
	};
})();
